import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { validString } from 'src/app/shared/utilities/types.utils';

@Injectable({
  providedIn: 'root',
})
export class TemporaryLoggerService {
  /** The parent session ID */
  private parentSessionId = '';
  /** Http client */
  private http = inject(HttpClient);

  /**
   * Log information to the
   * @param title The title of the log
   * @param msg The log message
   */
  log(title: string, msg: string) {
    if (!validString(this.parentSessionId)) {
      return;
    }
    return this.sendLog(title, msg);
  }

  setParentSessionId(sessionId: string) {
    this.parentSessionId = sessionId;
  }

  sendLog(title: string, msg: string) {
    this.http
      .post(this.buildUrl(), {
        m: msg,
        t: `accessoPay: ${title}`,
        s: this.parentSessionId,
      })
      .pipe(catchError(() => EMPTY))
      .subscribe();
  }

  /**
   * Builds our url for posting messages to
   */
  private buildUrl(): string {
    return `php/log/`;
  }
}
